import React from 'react';

import ObjectDisplay from 'components/ObjectDisplay'

const filterDateFields = (value, key) => {
  return !["visitedAt","createdAt","updatedAt"].includes(key);
}

const Details = props => {
  return (
    <div>
      <h3>Candidate Details</h3>
      <ObjectDisplay object={props.selected} filterFunc={filterDateFields}/>
    </div>
  );
};

import {initializer, selectors} from 'utils/resourcerizer';
import {connect} from 'react-redux';

import {CANDIDATES_NS} from 'constants/index';

const candidatesInitializer = initializer(CANDIDATES_NS)
const candidateSelectors = selectors(CANDIDATES_NS)

const mstp = (state,ownProps) => ({
  selected: candidateSelectors.findOneById(state,ownProps.candidateId)
})

Details.Container = candidatesInitializer(connect(mstp)(Details))

export default Details



// WEBPACK FOOTER //
// ./src/components/candidates/Details.jsx